export const calcDuration = (day: { lesson: { sections: any[] } }) => {
  const duration =
    day?.lesson?.sections && day.lesson.sections.some(x => x.activities.length > 0)
      ? day.lesson.sections
          ?.reduce(
            (a, s) => {
              const val = s.activities.map(({ duration }) => duration);
              return [...a, ...val];
            },
            [0]
          )
          .reduce((accumulator, currentValue) => accumulator + currentValue)
      : 0;

  return duration;
};

/** add custom resource id once available */
export const getActivityId = activity => {
  return activity?.resourceId || activity?.clickAwayId || activity?.pageId;
};
